import Papa from 'papaparse'
import { MAX_TABLE_CSV_FILE_SIZE } from '../statics/constants'

export function parseTableDataFromCsv (csvFile) {
  const result = Papa.parse(csvFile, {
    skipEmptyLines: true,
    dynamicTyping: false
  })

  if (result.data.length === 0) {
    return { headers: [], data: [] }
  }

  const headers = result.data[0]
  const data = result.data.slice(1)

  return { headers, data }
}

function validateTableCsvHeaders (csvHeaders, defaultHeaders) {
  if (defaultHeaders.length === 0) {
    throw new Error('Please set default table CSV for the parameter in App')
  }

  const areHeaderContentsEqual = defaultHeaders.every((defaultHeader, index) =>
    defaultHeader === csvHeaders[index]
  )

  const areHeadersEqual = defaultHeaders.length === csvHeaders.length && areHeaderContentsEqual

  if (!areHeadersEqual) {
    throw new Error('Headers in the provided CSV must match the default parameter headers.')
  }
}

function sanitizeTableHeaders (headers) {
  const trimmedHeaders = headers.map(header => header.trim())
  if (trimmedHeaders.some(header => header === '')) {
    throw new Error('CSV file contains one or more empty headers')
  }

  const uniqueHeaders = new Set(trimmedHeaders)
  if (uniqueHeaders.size !== headers.length) {
    throw new Error('CSV file contains duplicate headers')
  }

  return trimmedHeaders
}

function validateCsvFile (csvFile) {
  if (!csvFile) throw new Error('No CSV file provided')

  if (csvFile.size === 0) {
    throw new Error('The CSV file is empty')
  }

  if (csvFile.size > MAX_TABLE_CSV_FILE_SIZE) {
    throw new Error('File size should not exceed 200KB')
  }
}

export async function extractDataFromCsvOrThrow (csvFile, parameter) {
  try {
    validateCsvFile(csvFile)
    const csvData = await csvFile.text()
    const { headers, data } = parseTableDataFromCsv(csvData)

    const sanitizedHeaders = sanitizeTableHeaders(headers)

    if (!parameter) {
      throw new Error('Parameter not found')
    }

    const defaultHeaders = sanitizeTableHeaders(parameter.DefaultValue.Headers)

    validateTableCsvHeaders(sanitizedHeaders, defaultHeaders)

    data.forEach((row, index) => {
      if (row.length !== sanitizedHeaders.length) {
        throw new Error(`Row ${index + 1} does not match the number of headers.`)
      }
    })

    return { tableData: { headers: sanitizedHeaders, data } }
  } catch (err) {
    return { error: err.message || 'Failed to read the file. Please try again.' }
  }
}

export function saveCsv (csvContent, title) {
  const blob = new Blob([csvContent], {
    type: 'text/csvcharset=utf-8'
  })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${title}.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
